export const brandCategories = {
        brands: {
          "GBH": [
            "바디케어"
          ],
          "LBB": [
            "헤어케어",
            "스킨케어"
          ],
          "Te'": [
            "선케어"
          ],
          "ms.44": [
            "바디케어"
          ],
          "내추럴더마프로젝트": [
            "스킨케어"
          ],
          "네쉬": [
            "헤어케어"
          ],
          "딕셔니스트": [
            "스킨케어"
          ],
          "라돌프": [
            "스킨케어"
          ],
          "바버": [
            "스킨케어"
          ],
          "멘톨로지": [
            "클렌징"
          ],
          "모나이트": [
            "클렌징"
          ],
          "모두봄": [
            "헤어케어"
          ],
          "모레모포맨": [
            "헤어케어"
          ],
          "무백": [
            "헤어케어"
          ],
          "미라이크": [
            "바디케어"
          ],
          "바이아우어": [
            "헤어케어"
          ],
          "반코르": [
            "헤어케어",
            "스킨케어"
          ],
          "브리티시엠": [
            "헤어케어"
          ],
          "사브와 프로페셔널": [
            "헤어케어"
          ],
          "스콧해미쉬": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "써니콘": [
            "선케어"
          ],
          "아렌시아": [
            "클렌징",
            "스킨케어"
          ],
          "아이다": [
            "스킨케어"
          ],
          "어글리러블리": [
            "선케어"
          ],
          "에가": [
            "바디케어"
          ],
          "오드로이": [
            "스킨케어"
          ],
          "오브베이스": [
            "클렌징"
          ],
          "운스트라움": [
            "클렌징",
            "스킨케어"
          ],
          "유이크": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "제로시피": [
            "헤어케어"
          ],
          "인스테드": [
            "바디케어"
          ],
          "제나벨": [
            "선케어",
            "스킨케어"
          ],
          "제로이드": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "지아자": [
            "바디케어"
          ],
          "청미정": [
            "헤어케어"
          ],
          "케라스타즈": [
            "헤어케어"
          ],
          "케어놀로지": [
            "스킨케어"
          ],
          "클리어디어": [
            "스킨케어"
          ],
          "키엘": [
            "스킨케어"
          ],
          "프라나롬": [
            "스킨케어"
          ],
          "톰": [
            "스킨케어"
          ],
          "파이브센스": [
            "헤어케어"
          ],
          "풀리": [
            "클렌징"
          ],
          "휩드": [
            "스킨케어"
          ],
          "피토메르": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "핑크고스트": [
            "헤어케어"
          ],
          "헤이브로": [
            "스킨케어"
          ],
          "AHC": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "AZH": [
            "헤어케어"
          ],
          "CKD": [
            "헤어케어",
            "스킨케어",
            "선케어"
          ],
          "EGF올로지": [
            "스킨케어"
          ],
          "OOTD": [
            "스킨케어"
          ],
          "RMK": [
            "클렌징",
            "선케어"
          ],
          "SNP": [
            "선케어",
            "스킨케어"
          ],
          "SRB": [
            "클렌징"
          ],
          "TS샴푸": [
            "헤어케어"
          ],
          "VT": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "YNM": [
            "바디케어"
          ],
          "나드": [
            "헤어케어"
          ],
          "가히": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "갸스비": [
            "바디케어",
            "헤어케어"
          ],
          "라포티셀": [
            "스킨케어"
          ],
          "고잉그레이": [
            "헤어케어"
          ],
          "구달": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "궁중비책": [
            "클렌징",
            "바디케어",
            "선케어"
          ],
          "그라펜": [
            "바디케어",
            "헤어케어",
            "스킨케어"
          ],
          "그레이멜린": [
            "클렌징",
            "스킨케어"
          ],
          "그로우어스": [
            "바디케어",
            "헤어케어"
          ],
          "그린벨": [
            "바디케어"
          ],
          "그린핑거": [
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "글로오아시스": [
            "스킨케어"
          ],
          "꽃을든남자": [
            "헤어케어"
          ],
          "나르카": [
            "헤어케어"
          ],
          "나이팅게일": [
            "클렌징"
          ],
          "나인밀라": [
            "헤어케어"
          ],
          "나인위시스": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "나츄리에": [
            "바디케어"
          ],
          "낫츠": [
            "클렌징",
            "스킨케어"
          ],
          "낫포유": [
            "바디케어",
            "선케어"
          ],
          "내츄레인": [
            "클렌징"
          ],
          "냉감테라피": [
            "바디케어"
          ],
          "넘버즈인": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "넛세린": [
            "바디케어"
          ],
          "네오젠": [
            "클렌징",
            "스킨케어"
          ],
          "네이처리퍼블릭": [
            "헤어케어"
          ],
          "네츄럴샤인": [
            "바디케어"
          ],
          "노우라이": [
            "바디케어"
          ],
          "닥터원더": [
            "클렌징"
          ],
          "누들앤부": [
            "바디케어",
            "헤어케어"
          ],
          "누텍스처": [
            "바디케어",
            "스킨케어"
          ],
          "눅스": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "뉴라덤": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "뉴트로지나": [
            "클렌징",
            "바디케어"
          ],
          "뉴트리스톰": [
            "스킨케어"
          ],
          "니들리": [
            "클렌징"
          ],
          "니베아": [
            "바디케어",
            "선케어"
          ],
          "닐스야드 레머디스": [
            "바디케어",
            "스킨케어"
          ],
          "다나한": [
            "헤어케어"
          ],
          "다룸": [
            "스킨케어"
          ],
          "다슈": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "다이안": [
            "헤어케어"
          ],
          "다자연": [
            "선케어",
            "스킨케어"
          ],
          "닥터그루트": [
            "헤어케어"
          ],
          "닥터디퍼런트": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "닥터리핏": [
            "스킨케어"
          ],
          "닥터멜락신": [
            "스킨케어"
          ],
          "닥터바이오": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "닥터방기원": [
            "헤어케어",
            "스킨케어"
          ],
          "닥터벨머": [
            "클렌징",
            "바디케어"
          ],
          "닥터브로너스": [
            "바디케어",
            "스킨케어"
          ],
          "닥터시드": [
            "헤어케어"
          ],
          "닥터아토": [
            "클렌징",
            "바디케어",
            "선케어"
          ],
          "닥터오라클": [
            "스킨케어"
          ],
          "닥터올가": [
            "바디케어",
            "헤어케어",
            "선케어"
          ],
          "닥터자르트": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "닥터지": [
            0,
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "닥터트웬티프로젝트": [
            "스킨케어"
          ],
          "닥터포포": [
            "바디케어"
          ],
          "닥터포헤어": [
            "헤어케어"
          ],
          "닥터하스킨": [
            "스킨케어"
          ],
          "닥터하우쉬카": [
            "스킨케어"
          ],
          "달란": [
            "바디케어"
          ],
          "달리프": [
            "헤어케어"
          ],
          "달바": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "달팡": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "더랩바이블랑두": [
            "클렌징",
            "스킨케어"
          ],
          "더마비": [
            "바디케어",
            "선케어"
          ],
          "더마클라센": [
            "헤어케어"
          ],
          "더마토리": [
            "클렌징",
            "스킨케어"
          ],
          "더마펌": [
            "스킨케어"
          ],
          "더마픽스": [
            "스킨케어"
          ],
          "더말로지카": [
            "클렌징",
            "스킨케어"
          ],
          "더바디샵": [
            "클렌징",
            "바디케어",
            "헤어케어",
            "스킨케어"
          ],
          "더블유드레스룸": [
            "바디케어"
          ],
          "더블하트": [
            "바디케어"
          ],
          "더샘": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "더파이에센셜": [
            "클렌징",
            "스킨케어"
          ],
          "더페이스샵": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "더프트앤도프트": [
            "바디케어"
          ],
          "더하르나이": [
            "선케어",
            "스킨케어"
          ],
          "더후": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "데이퍼센트": [
            "스킨케어"
          ],
          "데저트 에센스": [
            "클렌징",
            "바디케어"
          ],
          "데트클리어": [
            "클렌징"
          ],
          "도루코": [
            "바디케어"
          ],
          "도미나스": [
            "스킨케어"
          ],
          "도브": [
            "바디케어",
            "헤어케어"
          ],
          "동구밭": [
            "바디케어",
            "헤어케어"
          ],
          "두잉왓": [
            "바디케어",
            "헤어케어"
          ],
          "듀왑": [
            "바디케어"
          ],
          "듀이셀": [
            "바디케어"
          ],
          "듀이트리": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "디마르3": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "디어달리아": [
            "선케어"
          ],
          "디어도어": [
            "바디케어"
          ],
          "디어클레어스": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "디에이브": [
            "스킨케어"
          ],
          "디오디너리": [
            "클렌징",
            "헤어케어",
            "바디케어",
            "스킨케어"
          ],
          "딘시": [
            "선케어"
          ],
          "딥퍼랑스": [
            "바디케어"
          ],
          "땡큐파머": [
            "클렌징",
            "스킨케어"
          ],
          "라곰": [
            "클렌징",
            "선케어"
          ],
          "라끄베르": [
            "바디케어",
            "스킨케어"
          ],
          "라끌랑": [
            "스킨케어"
          ],
          "라네즈": [
            "바디케어",
            "스킨케어"
          ],
          "라라레서피": [
            "스킨케어"
          ],
          "라라츄": [
            "헤어케어"
          ],
          "라피네르": [
            "바디케어"
          ],
          "라이아": [
            "헤어케어"
          ],
          "애프터블로우": [
            "바디케어"
          ],
          "라로슈포제": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "라로제": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "라보에이치": [
            "헤어케어"
          ],
          "라부르켓": [
            "바디케어"
          ],
          "라비오뜨": [
            "선케어"
          ],
          "라빠레뜨 뷰티": [
            "스킨케어"
          ],
          "라씨엘르": [
            "클렌징"
          ],
          "라엘": [
            "클렌징"
          ],
          "라온느": [
            "헤어케어"
          ],
          "라우쉬": [
            "헤어케어"
          ],
          "라운드랩": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "라운드어라운드": [
            "클렌징",
            "바디케어",
            "선케어"
          ],
          "라타플랑": [
            "선케어",
            "스킨케어"
          ],
          "라피타": [
            "헤어케어"
          ],
          "락토덤": [
            "바디케어"
          ],
          "랑벨": [
            "클렌징",
            "스킨케어"
          ],
          "랩시리즈": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "랩신": [
            "바디케어"
          ],
          "러븀": [
            "선케어"
          ],
          "러비더비": [
            "헤어케어"
          ],
          "런드리유": [
            "클렌징"
          ],
          "레시피": [
            "선케어"
          ],
          "레이비": [
            "바디케어"
          ],
          "레이지소사이어티": [
            "헤어케어",
            "스킨케어",
            "선케어"
          ],
          "려": [
            "헤어케어"
          ],
          "로더렛": [
            "바디케어"
          ],
          "로레알": [
            "헤어케어",
            "선케어"
          ],
          "로레알맨": [
            "클렌징",
            "스킨케어"
          ],
          "로마": [
            "헤어케어"
          ],
          "로벡틴": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "로우퀘스트": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "로이비": [
            "바디케어",
            "헤어케어"
          ],
          "로즐린": [
            "바디케어"
          ],
          "로픈": [
            "헤어케어"
          ],
          "록시땅": [
            "클렌징",
            "바디케어",
            "헤어케어",
            "스킨케어"
          ],
          "록키스": [
            "클렌징",
            "스킨케어"
          ],
          "롬앤": [
            "바디케어",
            "선케어"
          ],
          "롱테이크": [
            "바디케어",
            "헤어케어"
          ],
          "루시도엘": [
            "헤어케어"
          ],
          "루아페": [
            "바디케어"
          ],
          "루에브르": [
            "바디케어"
          ],
          "루토닉스": [
            "헤어케어"
          ],
          "루톤": [
            "헤어케어"
          ],
          "루트리": [
            "스킨케어"
          ],
          "르네휘테르": [
            "헤어케어"
          ],
          "르셀르": [
            "바디케어"
          ],
          "르오에스 ": [
            "바디케어"
          ],
          "리듀어": [
            "클렌징"
          ],
          "리르": [
            "클렌징",
            "헤어케어",
            "바디케어"
          ],
          "리얼베리어": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "리엔": [
            "헤어케어"
          ],
          "리엔케이": [
            "스킨케어"
          ],
          "리우젤": [
            "클렌징",
            "헤어케어",
            "스킨케어"
          ],
          "리쥬란": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "리터뉴": [
            "스킨케어"
          ],
          "리터니티": [
            "바디케어",
            "스킨케어"
          ],
          "리필드": [
            "헤어케어"
          ],
          "립리프": [
            "바디케어"
          ],
          "멘소래담": [
            "바디케어"
          ],
          "마녀공장": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "마데카솔": [
            "바디케어"
          ],
          "마르마르디": [
            "바디케어",
            "헤어케어"
          ],
          "마르시끄": [
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "마리엔메이": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "무슈제이": [
            "클렌징",
            "스킨케어"
          ],
          "마몽드": [
            "클렌징",
            "스킨케어"
          ],
          "마쉐리": [
            "헤어케어"
          ],
          "마이달리아": [
            "클렌징"
          ],
          "마일드랩": [
            "스킨케어"
          ],
          "마티나겝하르트": [
            "스킨케어"
          ],
          "맥": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "맥스클리닉": [
            "클렌징"
          ],
          "멀블리스": [
            "바디케어"
          ],
          "멈칫": [
            "바디케어",
            "헤어케어"
          ],
          "메디비티": [
            "클렌징"
          ],
          "메디앤서": [
            "선케어",
            "스킨케어"
          ],
          "메디올": [
            "헤어케어"
          ],
          "메디올가": [
            "스킨케어"
          ],
          "메디큐브": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "메디큐브 에이지알": [
            "스킨케어"
          ],
          "메디포포": [
            "바디케어"
          ],
          "메디필": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "메디힐": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "메르필": [
            "바디케어",
            "헤어케어"
          ],
          "메모": [
            "바디케어"
          ],
          "메소드": [
            "바디케어"
          ],
          "메이크프렘": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "멜로우터치": [
            "헤어케어"
          ],
          "멜린앤게츠": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "모다모다": [
            "헤어케어"
          ],
          "모레모": [
            "헤어케어"
          ],
          "모레모 케라틴": [
            "헤어케어"
          ],
          "모로칸오일": [
            0,
            "바디케어",
            "헤어케어"
          ],
          "모제림": [
            "헤어케어"
          ],
          "몰바니": [
            "클렌징",
            "스킨케어"
          ],
          "무스텔라": [
            "바디케어"
          ],
          "무칸": [
            "헤어케어"
          ],
          "뮤드": [
            "바디케어"
          ],
          "미구하라": [
            "스킨케어"
          ],
          "미샤": [
            "선케어",
            "스킨케어"
          ],
          "미쟝센": [
            "바디케어",
            "헤어케어"
          ],
          "미프": [
            "클렌징",
            "스킨케어"
          ],
          "바이오가": [
            "바디케어",
            "헤어케어"
          ],
          "믹순": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "밀크바오밥": [
            "바디케어",
            "헤어케어"
          ],
          "밀크터치": [
            "클렌징",
            "스킨케어"
          ],
          "바나다왁싱": [
            "바디케어"
          ],
          "바니니": [
            "바디케어"
          ],
          "바닐라코": [
            "클렌징",
            "선케어"
          ],
          "바디브": [
            "헤어케어"
          ],
          "바디언스": [
            "바디케어",
            "선케어"
          ],
          "바디판타지": [
            "바디케어"
          ],
          "바디홀릭": [
            "바디케어"
          ],
          "바르테라": [
            "스킨케어"
          ],
          "바버501": [
            "헤어케어",
            "스킨케어"
          ],
          "바비브라운": [
            "클렌징",
            "스킨케어"
          ],
          "바세린": [
            "바디케어",
            "선케어"
          ],
          "바이브랩": [
            "헤어케어"
          ],
          "바이애콤": [
            "클렌징"
          ],
          "바이오더마": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "바이오던스": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "바이오오일": [
            "바디케어"
          ],
          "바이오힐보": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "바티스트": [
            "헤어케어"
          ],
          "박준뷰티랩": [
            "헤어케어"
          ],
          "밤코스메틱": [
            "바디케어"
          ],
          "배드스킨": [
            "스킨케어"
          ],
          "백화유": [
            "바디케어"
          ],
          "버츠비": [
            "바디케어",
            "헤어케어"
          ],
          "베네자임": [
            "헤어케어"
          ],
          "베리홉": [
            "스킨케어"
          ],
          "벤튼": [
            "헤어케어",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "알보우": [
            "바디케어"
          ],
          "벨레다": [
            "바디케어"
          ],
          "벨먼": [
            "바디케어"
          ],
          "보나쥬르": [
            "클렌징",
            "스킨케어"
          ],
          "보다나": [
            "헤어케어"
          ],
          "보로탈코": [
            "바디케어"
          ],
          "보타믹스": [
            "헤어케어"
          ],
          "볼드포뮬러": [
            "클렌징",
            "스킨케어"
          ],
          "부쉬맨": [
            "선케어"
          ],
          "불독": [
            "클렌징",
            "스킨케어"
          ],
          "브링그린": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "브이앤에이뷰티": [
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "블라이드": [
            "클렌징"
          ],
          "블랑101": [
            "바디케어"
          ],
          "블랑네이처": [
            "클렌징"
          ],
          "블랙포레": [
            "헤어케어"
          ],
          "블리브유": [
            "선케어",
            "스킨케어"
          ],
          "블리블리": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "블리스텍스": [
            "바디케어"
          ],
          "비건이펙트": [
            "클렌징",
            "스킨케어"
          ],
          "비긴스": [
            "스킨케어"
          ],
          "비더마틱": [
            "바디케어"
          ],
          "비레디": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "비마이셀프": [
            "스킨케어"
          ],
          "비비드로우": [
            "스킨케어"
          ],
          "비알머드": [
            "클렌징"
          ],
          "비알티씨": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "비얼라우": [
            "스킨케어"
          ],
          "비엘렌다": [
            "클렌징"
          ],
          "비오텀": [
            "클렌징"
          ],
          "비오템": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "비오템 옴므": [
            "클렌징",
            "스킨케어"
          ],
          "비욘드": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "비원츠": [
            "스킨케어"
          ],
          "비클리닉스": [
            "바디케어"
          ],
          "비판톨": [
            "바디케어",
            "스킨케어"
          ],
          "비페스타": [
            "클렌징"
          ],
          "비프로젝트": [
            "클렌징"
          ],
          "비플레인": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "빌리프": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "사이오스": [
            "헤어케어"
          ],
          "산다화": [
            "클렌징"
          ],
          "살사랑": [
            "클렌징"
          ],
          "생블랑쉬": [
            "스킨케어"
          ],
          "생활공작소": [
            "바디케어"
          ],
          "생활도감": [
            "바디케어"
          ],
          "샤이샤이샤이": [
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "설화수": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "성분에디터": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "세바메드": [
            "바디케어"
          ],
          "세븐에이트": [
            "헤어케어"
          ],
          "세이프프렌즈": [
            "바디케어"
          ],
          "세잔느": [
            "바디케어"
          ],
          "세타필": [
            "클렌징",
            "바디케어",
            "헤어케어",
            "스킨케어"
          ],
          "센카": [
            "클렌징"
          ],
          "센텔리안24": [
            "클렌징",
            "스킨케어"
          ],
          "셀라딕스": [
            "스킨케어"
          ],
          "셀라피": [
            "바디케어"
          ],
          "셀러버": [
            "바디케어",
            "헤어케어"
          ],
          "셀리맥스": [
            "클렌징",
            "스킨케어"
          ],
          "셀린저": [
            "스킨케어"
          ],
          "알페신": [
            "헤어케어"
          ],
          "셀비엔": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "셀퓨전씨": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "소본": [
            "스킨케어"
          ],
          "소울": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "소프리스": [
            "바디케어"
          ],
          "솔랩": [
            "헤어케어"
          ],
          "솔테라피": [
            "바디케어"
          ],
          "숌": [
            "클렌징"
          ],
          "수려한": [
            "스킨케어"
          ],
          "수이사이": [
            "클렌징"
          ],
          "수이스킨": [
            "클렌징",
            "스킨케어"
          ],
          "수페": [
            "스킨케어"
          ],
          "숨37": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "쉬크": [
            "바디케어"
          ],
          "스노우버디": [
            "바디케어"
          ],
          "스와니코코": [
            "스킨케어"
          ],
          "스웨거": [
            "바디케어",
            "헤어케어"
          ],
          "스카이보틀": [
            "바디케어"
          ],
          "스케다": [
            "스킨케어"
          ],
          "스킨1004": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "스킨베네핏": [
            "헤어케어"
          ],
          "스킨시그널": [
            "클렌징"
          ],
          "스킨알엑스랩": [
            "바디케어"
          ],
          "스킨앤랩": [
            "선케어",
            "스킨케어"
          ],
          "스킨유": [
            "바디케어"
          ],
          "스킨푸드": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "스트라이덱스": [
            "클렌징"
          ],
          "스팀베이스": [
            "헤어케어"
          ],
          "슬로소피": [
            "클렌징",
            "스킨케어"
          ],
          "슬밋": [
            "바디케어"
          ],
          "앰플브라운": [
            "헤어케어"
          ],
          "시드물": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "시모먼트": [
            "스킨케어"
          ],
          "시세이도": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "시세이도 프로페셔널": [
            "헤어케어"
          ],
          "시카고": [
            "스킨케어"
          ],
          "아도르": [
            "헤어케어"
          ],
          "식물나라": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "실크테라피": [
            "헤어케어"
          ],
          "심플로그": [
            "클렌징"
          ],
          "싸이닉": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "쌍빠": [
            "바디케어",
            "스킨케어"
          ],
          "썸바이미": [
            "스킨케어"
          ],
          "썸블라썸": [
            "바디케어"
          ],
          "쏘내추럴": [
            "헤어케어",
            "스킨케어"
          ],
          "앰플엔": [
            "스킨케어"
          ],
          "쓰리": [
            "클렌징",
            "바디케어",
            "헤어케어",
            "선케어"
          ],
          "씨널스": [
            "스킨케어"
          ],
          "씨드비": [
            "클렌징",
            "헤어케어",
            "바디케어"
          ],
          "씨퓨리": [
            "바디케어",
            "헤어케어"
          ],
          "아넷사": [
            "선케어"
          ],
          "아누아": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "아닐로": [
            "헤어케어"
          ],
          "아떼": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "아로마티카": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "아르투아": [
            "바디케어"
          ],
          "아리얼": [
            "클렌징"
          ],
          "아발론": [
            "헤어케어"
          ],
          "에비앙": [
            "스킨케어"
          ],
          "아베다": [
            "클렌징",
            "바디케어",
            "헤어케어"
          ],
          "아벤느": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "아비노": [
            "바디케어",
            "스킨케어"
          ],
          "아비노베이비": [
            "바디케어"
          ],
          "아비브": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "아워글래스": [
            "바디케어"
          ],
          "아윌미백": [
            "바디케어"
          ],
          "아이깨끗해": [
            "바디케어"
          ],
          "아이디얼포맨": [
            "클렌징",
            "스킨케어"
          ],
          "아이레놀": [
            "선케어",
            "스킨케어"
          ],
          "아이레시피": [
            "클렌징",
            "선케어"
          ],
          "아이보들": [
            "바디케어"
          ],
          "애즈이즈투비": [
            "선케어",
            "스킨케어"
          ],
          "아이소이": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "아이오페": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "아임프롬": [
            "클렌징",
            "스킨케어"
          ],
          "아크네스": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "아크웰": [
            "클렌징",
            "스킨케어"
          ],
          "아큼두": [
            "헤어케어"
          ],
          "아토808": [
            "바디케어"
          ],
          "아토뮤": [
            "클렌징"
          ],
          "아토앤오투": [
            "바디케어"
          ],
          "언파": [
            "바디케어"
          ],
          "얼라이브랩": [
            "헤어케어"
          ],
          "아토팜": [
            "클렌징",
            "바디케어",
            "헤어케어"
          ],
          "아트릭스": [
            "바디케어"
          ],
          "안달로우": [
            "헤어케어"
          ],
          "야다": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "어네이즈": [
            "헤어케어"
          ],
          "어노브": [
            "헤어케어"
          ],
          "어뮤즈": [
            "선케어"
          ],
          "어바웃미": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "어터": [
            "바디케어"
          ],
          "어퓨": [
            "헤어케어",
            "스킨케어"
          ],
          "언라이프": [
            "헤어케어"
          ],
          "얼트루": [
            "스킨케어"
          ],
          "에끌라두": [
            0,
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "에너비45": [
            "바디케어"
          ],
          "에디션바이아모레": [
            "바디케어"
          ],
          "에딧비": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "에뛰드": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "에르쯔틴": [
            "스킨케어"
          ],
          "에브리톡톡": [
            "헤어케어"
          ],
          "에센허브": [
            "클렌징",
            "헤어케어",
            "스킨케어",
            "바디케어"
          ],
          "에스네이처": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "에스쁘아": [
            "선케어"
          ],
          "에스테덤": [
            "스킨케어"
          ],
          "에스트라": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "에스티로더": [
            "클렌징",
            "헤어케어",
            "선케어",
            "스킨케어"
          ],
          "에이르보": [
            "헤어케어"
          ],
          "오스트레일리안골드": [
            "선케어"
          ],
          "에이지투웨니스": [
            "선케어"
          ],
          "에이트루": [
            "클렌징",
            "선케어"
          ],
          "에이프릴스킨": [
            "클렌징"
          ],
          "에코글램": [
            "헤어케어"
          ],
          "에퓨놀": [
            "헤어케어"
          ],
          "에필로우": [
            "클렌징",
            "스킨케어"
          ],
          "엔시피": [
            "바디케어"
          ],
          "엘라스틴": [
            "헤어케어"
          ],
          "엘리자베스아덴": [
            "바디케어"
          ],
          "엠도씨": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "엠디스픽": [
            "바디케어"
          ],
          "엠브리올리스": [
            "클렌징",
            "스킨케어"
          ],
          "오가니스트": [
            "헤어케어"
          ],
          "오디드": [
            "바디케어",
            "헤어케어"
          ],
          "오딧세이": [
            "스킨케어"
          ],
          "오루트": [
            "헤어케어"
          ],
          "오브제": [
            "헤어케어",
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "오센트": [
            "바디케어"
          ],
          "오어스": [
            "스킨케어"
          ],
          "오우썸": [
            "스킨케어"
          ],
          "오울루": [
            "바디케어"
          ],
          "오제끄": [
            "바디케어",
            "선케어"
          ],
          "오킵스": [
            "바디케어"
          ],
          "오프온": [
            "바디케어"
          ],
          "오휘": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "온그리디언츠": [
            "클렌징",
            "스킨케어"
          ],
          "온더바디": [
            "클렌징",
            "바디케어",
            "선케어"
          ],
          "올라플렉스": [
            "헤어케어"
          ],
          "올로스": [
            "스킨케어"
          ],
          "올리세": [
            "스킨케어"
          ],
          "우노": [
            "클렌징",
            "스킨케어"
          ],
          "우르오스": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "울트라브이": [
            "스킨케어"
          ],
          "원데이즈유": [
            "클렌징"
          ],
          "원씽": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "원오브뎀": [
            "스킨케어"
          ],
          "원진이펙트": [
            "스킨케어"
          ],
          "웨신": [
            "바디케어"
          ],
          "웰라쥬": [
            "클렌징",
            "스킨케어"
          ],
          "위드비컨": [
            "헤어케어"
          ],
          "유리아쥬": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "유리카": [
            "헤어케어"
          ],
          "유리프": [
            "클렌징"
          ],
          "유리피부": [
            "클렌징"
          ],
          "유세린": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "유스데스크": [
            "클렌징"
          ],
          "이니스프리": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "이브로쉐": [
            "클렌징",
            "헤어케어"
          ],
          "이아소": [
            "클렌징",
            "스킨케어"
          ],
          "이자녹스": [
            "스킨케어"
          ],
          "이즈앤트리": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "이지듀": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "이지엔": [
            "헤어케어"
          ],
          "이퀄베리": [
            "클렌징"
          ],
          "인터미션": [
            "스킨케어"
          ],
          "일리윤": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "일소": [
            "클렌징",
            "스킨케어"
          ],
          "잇츠스킨": [
            "스킨케어"
          ],
          "잇퍼": [
            "클렌징"
          ],
          "자빈드서울": [
            "클렌징"
          ],
          "자연이랑": [
            "헤어케어"
          ],
          "자트인사이트": [
            "스킨케어"
          ],
          "저스트에즈아이엠": [
            "헤어케어"
          ],
          "정샘물": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "제니하우스": [
            "헤어케어"
          ],
          "제이듀": [
            "바디케어"
          ],
          "제이숲": [
            "헤어케어"
          ],
          "제이엠솔루션": [
            "클렌징",
            "스킨케어"
          ],
          "조선미녀": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "조성아": [
            "스킨케어"
          ],
          "존슨즈": [
            "바디케어",
            "헤어케어"
          ],
          "존프리다": [
            "헤어케어"
          ],
          "졸렌": [
            "헤어케어"
          ],
          "주미소": [
            "클렌징",
            "스킨케어"
          ],
          "줄라이미": [
            "바디케어",
            "헤어케어"
          ],
          "지오마": [
            "바디케어"
          ],
          "차앤박": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "차앤박옴므": [
            "스킨케어"
          ],
          "차홍": [
            "바디케어",
            "헤어케어"
          ],
          "퓨어멜로우": [
            "선케어"
          ],
          "코랩": [
            "헤어케어"
          ],
          "착한팩토리": [
            "헤어케어"
          ],
          "참존": [
            "클렌징"
          ],
          "청담남자": [
            "헤어케어"
          ],
          "체이싱래빗": [
            "바디케어",
            "스킨케어"
          ],
          "취": [
            "바디케어"
          ],
          "츠바키": [
            "헤어케어"
          ],
          "카멕스": [
            "바디케어"
          ],
          "카밀": [
            "바디케어"
          ],
          "카트린": [
            "선케어"
          ],
          "칼앤한스": [
            "바디케어"
          ],
          "캐스키드슨": [
            "바디케어"
          ],
          "커리쉴": [
            "헤어케어"
          ],
          "컬러랩스": [
            "선케어"
          ],
          "컴포트존": [
            "스킨케어"
          ],
          "케라시스": [
            "헤어케어"
          ],
          "케어존": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "코스노리": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "코스알엑스": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "코스톡": [
            "스킨케어"
          ],
          "코시에로": [
            "바디케어"
          ],
          "콤마나인": [
            "바디케어"
          ],
          "콴디": [
            "클렌징"
          ],
          "쿤달": [
            "바디케어",
            "헤어케어"
          ],
          "큐가든": [
            "바디케어"
          ],
          "큐어": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "크리넥스": [
            "바디케어"
          ],
          "크리니크": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "크리스탈": [
            "바디케어",
            "선케어"
          ],
          "폰즈": [
            "클렌징"
          ],
          "클라뷰": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "클럽맨피노드": [
            "스킨케어"
          ],
          "클로란": [
            "헤어케어"
          ],
          "키네프": [
            "스킨케어"
          ],
          "키노닉스": [
            "클렌징",
            "스킨케어"
          ],
          "키스": [
            "바디케어",
            "선케어"
          ],
          "키스미": [
            "클렌징"
          ],
          "타입넘버": [
            "바디케어"
          ],
          "탱글엔젤": [
            "헤어케어"
          ],
          "테라로직": [
            "선케어",
            "스킨케어"
          ],
          "테일러센츠": [
            "바디케어"
          ],
          "토니모리": [
            "클렌징",
            "헤어케어",
            "스킨케어",
            "선케어"
          ],
          "토르홉": [
            "클렌징"
          ],
          "토리든": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "토코보": [
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "톡스앤필": [
            "선케어",
            "스킨케어"
          ],
          "휴캄": [
            "스킨케어"
          ],
          "톤28": [
            "클렌징",
            "헤어케어",
            "바디케어",
            "스킨케어"
          ],
          "톤핏선": [
            "선케어"
          ],
          "투비건": [
            "클렌징"
          ],
          "투쿨포스쿨": [
            "헤어케어"
          ],
          "투크": [
            "클렌징"
          ],
          "투힐미": [
            "바디케어"
          ],
          "트러블레스": [
            "스킨케어"
          ],
          "트루자임": [
            "헤어케어"
          ],
          "트리셀": [
            "바디케어",
            "헤어케어"
          ],
          "트리헛": [
            "바디케어"
          ],
          "트릴로지": [
            "스킨케어"
          ],
          "티스": [
            "클렌징"
          ],
          "티엘스": [
            "클렌징",
            "스킨케어"
          ],
          "티컬렉티브": [
            "바디케어"
          ],
          "티타드": [
            "헤어케어"
          ],
          "파넬": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "파놀라": [
            "헤어케어"
          ],
          "피캄": [
            "클렌징",
            "스킨케어"
          ],
          "파티온": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "파파레서피": [
            "클렌징",
            "스킨케어"
          ],
          "팬틴": [
            "헤어케어"
          ],
          "퍼셀": [
            "스킨케어"
          ],
          "포레스트스토리": [
            "헤어케어"
          ],
          "포르맨즈": [
            "스킨케어"
          ],
          "포맨트": [
            "바디케어",
            "스킨케어"
          ],
          "포뷰트": [
            "헤어케어"
          ],
          "포엘리에": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "포이유이": [
            "클렌징"
          ],
          "포인트앤": [
            "클렌징"
          ],
          "폴라레나": [
            "바디케어"
          ],
          "폴라초이스": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "폴미첼": [
            "헤어케어"
          ],
          "푸룻스킨": [
            "바디케어"
          ],
          "퓨어덤": [
            "스킨케어"
          ],
          "프라이멀 엘리먼츠": [
            "바디케어"
          ],
          "프란츠": [
            "스킨케어"
          ],
          "프랭클리": [
            "스킨케어"
          ],
          "프레쉬라이트": [
            "헤어케어"
          ],
          "프롬리에": [
            "선케어"
          ],
          "프리메라": [
            "클렌징",
            "바디케어",
            "스킨케어",
            "선케어"
          ],
          "플라스킨": [
            "스킨케어"
          ],
          "플란투어": [
            "헤어케어"
          ],
          "플로운": [
            "클렌징",
            "스킨케어"
          ],
          "플루": [
            "클렌징",
            "바디케어"
          ],
          "플르부아": [
            "바디케어"
          ],
          "플리프": [
            "클렌징",
            "스킨케어"
          ],
          "피노": [
            "헤어케어"
          ],
          "피부미": [
            "스킨케어"
          ],
          "피브": [
            "바디케어"
          ],
          "피지오겔": [
            "클렌징",
            "바디케어",
            "선케어",
            "스킨케어"
          ],
          "필로소피": [
            "바디케어"
          ],
          "필리더스": [
            "바디케어"
          ],
          "필립비": [
            "헤어케어"
          ],
          "하다라보": [
            "클렌징",
            "스킨케어"
          ],
          "하루하루원더": [
            "스킨케어"
          ],
          "하멜": [
            "클렌징",
            "선케어"
          ],
          "하아르": [
            "헤어케어"
          ],
          "하트퍼센트": [
            "클렌징"
          ],
          "한스킨": [
            "클렌징"
          ],
          "한율": [
            "클렌징",
            "바디케어",
            "스킨케어"
          ],
          "해서린": [
            "클렌징"
          ],
          "해피바스": [
            "클렌징",
            "바디케어"
          ],
          "허니체": [
            "헤어케어"
          ],
          "허바신": [
            "바디케어"
          ],
          "허벌에센스": [
            "헤어케어"
          ],
          "허브노트": [
            "스킨케어"
          ],
          "허블룸": [
            "선케어",
            "스킨케어"
          ],
          "허스텔러": [
            "바디케어",
            "스킨케어"
          ],
          "헉슬리": [
            "바디케어",
            "헤어케어",
            "스킨케어"
          ],
          "헤드스파7": [
            "헤어케어"
          ],
          "헤드앤숄더": [
            "헤어케어"
          ],
          "헤라": [
            "클렌징",
            "선케어",
            "스킨케어",
            "바디케어"
          ],
          "헤브블루": [
            "클렌징",
            "스킨케어"
          ],
          "헤어플러스": [
            "헤어케어"
          ],
          "헤이네이처": [
            "클렌징",
            "스킨케어"
          ],
          "헤이미쉬": [
            "클렌징"
          ],
          "헤트라스": [
            "바디케어"
          ],
          "홀리카홀리카": [
            "선케어"
          ],
          "후르디아": [
            "클렌징",
            "바디케어"
          ],
          "후시다인": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "휘게": [
            "클렌징",
            "선케어",
            "스킨케어"
          ],
          "히든": [
            "바디케어"
          ],
          "히든앤코": [
            "바디케어"
          ],
          "히말라야": [
            "바디케어"
          ],
          "히야 (HYAAH)": [
            "클렌징",
            "선케어"
          ],
          "힐링버드": [
            "헤어케어"
          ]
        }
      };
    export default brandCategories;